import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import FilterContext from '../../contexts/FilterContext';
import { FaPlus, FaMinus } from 'react-icons/fa';
import { COLORS } from '../../constants/colors';

const CategorySection = ({ topLevelCategory = null, searchMode = false }) => {
  const [showSubcategories, setShowSubcategories] = useState(true); // State to control subcategories visibility
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const { selectedStatus } = React.useContext(FilterContext);

  const plum = COLORS.PLUM;
  const warmConcrete = COLORS.WARM_CONCRETE;

  useEffect(() => {
    setIsLoading(false);
  }, [topLevelCategory, searchMode]);

  // Toggle all subcategories visibility
  const toggleSubcategories = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowSubcategories(!showSubcategories);
  };

  // Get appropriate count based on current filter status
  const getFilteredCount = (category) => {
    if (!category.product_counts) return 0;
    
    if (selectedStatus === 'all') {
      return category.product_counts.total;
    } else if (selectedStatus === '1') {
      return category.product_counts.live;
    } else if (selectedStatus === '2') {
      return category.product_counts.ended;
    } else if (selectedStatus === '3') {
      return category.product_counts.upcoming;
    }
    
    return category.product_counts.total;
  };

  const renderCategories = (category, isTopLevel = true) => {
        
    if (!category) {
      return null;
    }

    // Handle the case where category is in a results array
    const categoryData = category.results ? category.results[0] : category;
    if (!categoryData) {
      return null;
    }

    const categoriesToMap = isTopLevel && !searchMode ? categoryData.subCategory : categoryData;
    
    return (
      <ul className='list-unstyled m-0' style={isTopLevel ? { width: '100%' } : { }}>
        {isTopLevel && (
          <li className='text-center'>
            <Col className='border-bottom border-top py-2 fs-6 fw-semibold'>
              <div className='d-flex justify-content-center align-items-center'>
                <span className='d-flex align-items-center'>
                  {searchMode ? 'All Categories' :  categoryData.name}
                  {!searchMode && categoryData.product_counts && categoryData.product_counts.total > 0 && (
                    <span className="ms-1 text-muted">({getFilteredCount(categoryData)})</span>
                  )}
                </span>
                {!searchMode && categoryData.subCategory && categoryData.subCategory.length > 0 && (
                  <div 
                    className='ms-2 d-flex align-items-center justify-content-center'
                    onClick={toggleSubcategories}
                    style={{ 
                      cursor: 'pointer',
                      padding: '4px',
                      borderRadius: '4px',
                      transition: 'background-color 0.2s'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = warmConcrete}
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                  >
                    {showSubcategories ? 
                      <FaMinus color={plum} size={14} /> : 
                      <FaPlus color={plum} size={14} />
                    }
                  </div>
                )}
              </div>
            </Col>
          </li>
        )}
        {showSubcategories && Array.isArray(categoriesToMap) ? categoriesToMap.map((subCategory) => {
          const count = getFilteredCount(subCategory);
          return (
            <li key={subCategory._id} className="mt-3 mt-md-2 mt-xl-0 mx-2 mx-md-0">
              <Row className='d-flex flex-row justify-content-center align-items-center category-item rounded'>
                <Link 
                  to={`/categories/${subCategory.slug}-c-${subCategory._id}`} 
                  className='link-dark text-decoration-none col-12'
                >
                  {subCategory.name}
                  {subCategory.product_counts && (
                    <span className={`ms-1 ${count > 0 ? 'text-success' : 'text-muted'}`}>
                      ({count})
                    </span>
                  )}
                </Link>
              </Row>
            </li>
          );
        }) : null}
      </ul>
    );
  };

  if (isLoading) {
    return (
      <div className='category-section my-2 justify-content-center'>
        <div className="text-center">Loading categories...</div>
      </div>
    );
  }

  if (!topLevelCategory) {
    return (
      <div className='category-section my-2 justify-content-center'>
        <div className="text-center">No categories available</div>
      </div>
    );
  }

  return (
    <div className='category-section my-2 justify-content-center'>
      {renderCategories(topLevelCategory)}
    </div>
  );
};

export default CategorySection;
